export const CopyIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.6145 2.27002H10.0347C11.4293 2.27002 12.1267 2.27002 12.6594 2.54144C13.1279 2.78019 13.5089 3.16114 13.7476 3.62971C14.019 4.1624 14.019 4.85973 14.019 6.25439V10.6746M4.80518 13.4761H9.8479C10.5452 13.4761 10.8939 13.4761 11.1602 13.3404C11.3945 13.221 11.585 13.0305 11.7044 12.7962C11.8401 12.5299 11.8401 12.1812 11.8401 11.4839V6.44116C11.8401 5.74383 11.8401 5.39517 11.7044 5.12882C11.585 4.89454 11.3945 4.70406 11.1602 4.58468C10.8939 4.44897 10.5452 4.44897 9.8479 4.44897H4.80518C4.10784 4.44897 3.75918 4.44897 3.49283 4.58468C3.25855 4.70406 3.06807 4.89454 2.9487 5.12882C2.81299 5.39517 2.81299 5.74383 2.81299 6.44116V11.4839C2.81299 12.1812 2.81299 12.5299 2.9487 12.7962C3.06807 13.0305 3.25855 13.221 3.49283 13.3404C3.75918 13.4761 4.10784 13.4761 4.80518 13.4761Z"
        stroke="black"
        strokeWidth="0.933838"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
